import template from './offer_button.html';

angular.module('caferealtor.offer.list').component('bbOfferButton', {
  transclude: true,
  bindings: {
    listingId: '<',
    offerId: '<',
  },
  controller: OfferButtonController,
  controllerAs: 'vm',
  template,
});

OfferButtonController.$inject = ['$rootScope', 'ModalService'];
function OfferButtonController($rootScope, ModalService) {
  const vm = this;

  vm.$onInit = () => {
    vm.auth = $rootScope.auth;
  };

  vm.openPreview = () => {
    ModalService.openOfferModal(vm.listingId, vm.offerId, 'all');
  };
}

export {};
